<div>
  <p *ngIf="!updateCompleted">Bitte ändern Sie Ihr Kennwort.</p>
  <p *ngIf="updateCompleted">
    Ihr Passwort wurde erfolgreich aktualisiert. <br />

    <button
      id="submit"
      class="btn btn-block form-control"
      @inAnimation
      routerLink="/"
    >
      Schulio starten
    </button>
  </p>
  <p *ngIf="updateLoading">Bitte warten...</p>
  <div *ngIf="!updateLoading && !updateCompleted">
    <input
      type="password"
      autocomplete="off"
      [(ngModel)]="password1"
      #password1Input="ngModel"
      name="password1Input"
      id="password1Input"
      class="form-control"
      placeholder="Passwort"
      pattern="\s{8}\s*"
      focusInput
      required
      (keydown.enter)="FormAutomation.FocusNextChild($event)"
      @inOutAnimation
    />
    <input
      type="password"
      autocomplete="off"
      [(ngModel)]="password2"
      #password2Input="ngModel"
      name="password2Input"
      id="password2Input"
      class="form-control"
      placeholder="Passwort wiederholen"
      [pattern]="password1"
      required
      (keydown.enter)="FormAutomation.FocusNextChild($event)"
      @inOutAnimation
    />
    <p
      style="display: block"
      *ngIf="
        !(
          password1.length > 7 &&
          password1 == password2 &&
          hasUpperCaseCharacter() &&
          hasSpecialCharacter()
        )
      "
    >
      mind. 8 Zeichen, einen Großbuchstaben und ein Sonderzeichen
    </p>
    <button
      id="submit"
      class="btn btn-block form-control"
      [disabled]="
        !(
          password1.length > 7 &&
          password1 == password2 &&
          hasUpperCaseCharacter() &&
          hasSpecialCharacter()
        )
      "
      @inAnimation
      (click)="submit()"
    >
      Passwort ändern
    </button>

    <p>Bitte notieren Sie Ihr Passwort keinesfalls auf Papier.</p>
  </div>
</div>
